var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Configure " + _vm._s(_vm.template.name) + " Table"),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "rb-input",
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("How many Room Types will you allow?"),
              ]),
              _c(
                "rb-select",
                {
                  staticClass: "simple",
                  model: {
                    value: _vm.data.roomType,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "roomType", $$v)
                    },
                    expression: "data.roomType",
                  },
                },
                [
                  _c("rb-option", { attrs: { value: [1] } }, [
                    _vm._v("One Room Type"),
                  ]),
                  _c("rb-option", { attrs: { value: [1, 2] } }, [
                    _vm._v("Two Room Types"),
                  ]),
                  _c("rb-option", { attrs: { value: [1, 2, 3] } }, [
                    _vm._v("Three Room Types"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "rb-input",
            { attrs: { error: _vm.$showError("rates") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Rates"),
              ]),
              _c(
                "rb-checkboxes",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    field: _vm.fields["rates"],
                    name: "rates",
                    "data-vv-as": "Rates",
                  },
                  model: {
                    value: _vm.data.rate,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "rate", $$v)
                    },
                    expression: "data.rate",
                  },
                },
                [
                  _c("rb-checkbox", { attrs: { value: "LRA" } }, [
                    _vm._v("LRA"),
                  ]),
                  _c("rb-checkbox", { attrs: { value: "NLRA" } }, [
                    _vm._v("NLRA"),
                  ]),
                  _c("rb-checkbox", { attrs: { value: "GOVT" } }, [
                    _vm._v("GOVT"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "rb-input",
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Occupancy"),
              ]),
              _c(
                "rb-select",
                {
                  staticClass: "simple",
                  model: {
                    value: _vm.data.occupancy,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "occupancy", $$v)
                    },
                    expression: "data.occupancy",
                  },
                },
                [
                  _c("rb-option", { attrs: { value: ["SGL"] } }, [
                    _vm._v("Single Only"),
                  ]),
                  _c("rb-option", { attrs: { value: ["DBL"] } }, [
                    _vm._v("Double Only"),
                  ]),
                  _c("rb-option", { attrs: { value: ["SGL", "DBL"] } }, [
                    _vm._v("Both"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { class: _vm.$style.heading }, [_vm._v("Rate Rules")]),
          _c("p", { class: _vm.$style.p }, [
            _vm._v(
              "Do not allow supplier to provide rate that exceeds percentage over last year’s rate"
            ),
          ]),
          _c(
            "rb-input",
            {
              attrs: {
                "for-id": "rateRules",
                error: _vm.$showError("rateRules"),
              },
            },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Percent"),
              ]),
              _c("span", { attrs: { slot: "hint" }, slot: "hint" }, [
                _vm._v("[0 - disabled]"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.rateRules.amount,
                    expression: "data.rateRules.amount",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|decimal:2|max_value:1000|min_value:0",
                    expression:
                      "'required|decimal:2|max_value:1000|min_value:0'",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "rateRules",
                  type: "text",
                  name: "rateRules",
                  "data-vv-as": "Rate Rule",
                },
                domProps: { value: _vm.data.rateRules.amount },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data.rateRules, "amount", $event.target.value)
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }